// Pure function, no Angular DI. Single capability-check guard (docs/offline-mode-plan.md
// §5/§10/P5): false hides offline video entirely on that browser/device; every other offline
// feature still ships (matches the plan's iOS-degrade framing).
//
// Checks for Service Worker support, not MediaSource — see offline-video-sw.js's header
// comment for why: P5's downloaded video is a single progressive MP4 per rendition (D4), and
// MediaSource.appendBuffer() needs fragmented ISO BMFF input to append incrementally, which
// a progressive MP4 is not. The dedicated SW decrypting Range responses is the mechanism that
// actually matches what gets downloaded and stored.
//
// No Blob-URL fallback for video either: P0 measured a ~1.08x plaintext-to-heap ratio
// (46.8MB heap for a 41.3MB file), already ruled out for lesson-length video
// (docs/refactor/offline-P0-findings.md).
export function offlineVideoSupported(): boolean {
  return !!navigator.serviceWorker && typeof ReadableStream !== 'undefined' && typeof crypto?.subtle?.decrypt === 'function';
}
